<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.50124 16.0001C4.67281 16.0001 4 15.3285 4 14.5001V8.54487C4 8.04775 4.24629 7.58292 4.65759 7.30375L9.1576 4.24937C9.66617 3.90418 10.3338 3.90418 10.8424 4.24937L15.3424 7.30375C15.7537 7.58292 16 8.04775 16 8.54487V14.5001C16 15.3285 15.3272 16.0001 14.4987 16.0001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.68506 11.5H11.3101C11.7933 11.5 12.1851 11.8917 12.1851 12.375V16.75L9.99756 15.4375L7.81006 16.75V12.375C7.81006 11.8917 8.20181 11.5 8.68506 11.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TeamAdsIcon'
}
</script>

